import { maskPhone } from '@/utils/common'

const mask = (date: any) => maskPhone(date)

export default mask
